export default __webpack_public_path__ + "9d43264edb0a534f44a7f1f6f70cbb78.svg";